import React from 'react';

export default ({ className, ...other }) => (
  <svg
    {...other}
    className={`icon w-bars ${className || ''}`}
    viewBox="0 0 28.339 20.781"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Group_301"
      data-name="Group 301"
      transform="translate(-659.661 -39.219)"
    >
      <rect
        id="Rectangle_168"
        data-name="Rectangle 168"
        width="3.779"
        height="28.339"
        rx="1.889"
        transform="translate(688 39.218) rotate(90)"
        fill="#54c6e0"
      />
      <rect
        id="Rectangle_169"
        data-name="Rectangle 169"
        width="3.779"
        height="28.339"
        rx="1.889"
        transform="translate(688 47.72) rotate(90)"
        fill="#54c6e0"
      />
      <rect
        id="Rectangle_170"
        data-name="Rectangle 170"
        width="3.779"
        height="28.339"
        rx="1.889"
        transform="translate(688 56.221) rotate(90)"
        fill="#54c6e0"
      />
    </g>
  </svg>
);
